import React from "react";
import { moreProducts } from "../mock";

export default function MoreProductsSection() {
  return (
    <section id="more" className="bg-[color:var(--dms-cream)] py-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 text-center">
        <p className="kicker">Also available</p>
        <h2 className="font-serif text-4xl md:text-5xl text-[color:var(--dms-navy)] mt-4">More from Design My Story</h2>
        <div className="w-14 h-[2px] bg-[color:var(--dms-peach)] mx-auto mt-5" />
        <p className="mt-6 text-[color:var(--dms-navy)]/70 max-w-xl mx-auto">Shirts are what we're known for. These are the rest of the things we print.</p>
      </div>
      <div className="max-w-7xl mx-auto px-5 lg:px-8 mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {moreProducts.map((p) => (
          <a href="#" key={p.title} className="group bg-white rounded-2xl overflow-hidden border border-[color:var(--dms-navy)]/10 hover-lift block">
            <div className="aspect-square overflow-hidden bg-[color:var(--dms-cream-2)]">
              <img src={p.img} alt={p.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
            </div>
            <div className="p-5">
              <h3 className="font-serif text-xl text-[color:var(--dms-navy)]">{p.title}</h3>
              <p className="mt-2 text-sm text-[color:var(--dms-navy)]/60">{p.desc}</p>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}
